// extracted by mini-css-extract-plugin
export default {"name":"BlockImageLink_name__pDC0S","image":"BlockImageLink_image__v90Fw","componentWrapper":"BlockImageLink_componentWrapper__jAOW2","fullHeight":"BlockImageLink_fullHeight__ApspV"};